import axios from "axios";
import { Axios, baseUrl } from "../../Services/Axios";

export const fetchOrders = async (url = undefined, params = undefined) => {
  return await Axios.get(url || `/admin/orders?status=all&${params || ""}`, {
    responseType: "json",
  });
};
// export const fetchCoupon = async (payload) => {
//   return await Axios.post("/admin/apply-coupon", payload);
// };
export const fetchCoupon = async (payload) => {
  return await Axios.post("/v2/admin/apply-coupon", payload);
};
export const fetchOrdersByCustomer = async (
  customerId = undefined,
  url = undefined,
  params = undefined
) => {
  return await Axios.get(
    url || `/admin/customers/orders/${customerId}?status=all&${params || ""}`,
    {
      responseType: "json",
    }
  );
};
export const fetchOrderDetails = async (id) => {
  return await Axios.get(`/admin/orders/${id}`, { responseType: "json" });
};
export const fetchLaundryItem = async ({
  serviceId,
  categoryId,
  limit,
  offset,
  zoneId,
}) => {
  const token = localStorage.getItem("token");
  return await axios.get(
    `${baseUrl}/api/laundry-item/list/service/${serviceId}/category/${categoryId}?limit=${limit}&offset=${offset}`,
    {
      headers: {
        Laundryzoneid: zoneId,
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    }
  );
};
export const fetchTimeSlot = async (
  date,
  type,
  orderType,
  zone,
  p_id,
  p_date
) => {
  // const zone = sessionStorage.getItem("zone");
  return await Axios.get(
    `/time-slots/list/${zone}/${date}/${(type, type)}/${orderType}${
      p_id && p_date ? `?p_id=${p_id}&p_date=${p_date}` : ""
    }`
  );
};
export const updateOrder = async (payload) => {
  return await Axios.post("/admin/update-orders", payload, {
    responseType: "json",
  });
};

// export const updateOrder = async (payload) => {
//   const { lessDc, ...rest } = payload;
//   return await Axios.post("/admin/update-orders", rest, {
//     params: { lessDc },
//     responseType: "json",
//   });
// };